import { stringify } from 'qs';
import deepmerge from 'deepmerge';
import { plainToInstanceWithLVS, AbstractFacade } from '@goparrot/common';
import { ItemListResponseDto } from '../dto';
import { StoreItemsExposeGroup } from '../enum';
export class MerchantItemFacade extends AbstractFacade {
    constructor(config, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_STORE_ITEM_V2,
                },
            },
            config || {},
        ]), interceptors);
    }
    async list(merchantId, pagination, params) {
        const query = stringify({ ...pagination, ...params });
        return plainToInstanceWithLVS(ItemListResponseDto, (await this.client.get(`/api/v2/merchant/${encodeURIComponent(merchantId)}/items?${query}`)).data, { groups: [StoreItemsExposeGroup.READ], exposeUnsetFields: false });
    }
}
//# sourceMappingURL=MerchantItemFacade.js.map